import * as React from 'react';

import { CustomDialog } from 'components/Dialogs/CustomDialog';
import { MessageDeliveryErrorForm } from '../MessageDeliveryErrorForm';

import styles from './styles.module.scss';
import { AnimatedLoaderModal } from '../../../../components/Loaders/AnimatedLoader';
import { IReviewDocument } from '../../../../common/request/interfaces/reviewDocument';
import { TwilioError } from '../../../../integrations/twilio/error/types';

type InputProps = {
  isLoading: boolean;
  isDelivered: boolean;
  open: boolean;
  setOpen: (open: boolean) => void;
  request: IReviewDocument;
  candidateUploadLink: string;
  onChangePhone: (v: string) => void;
  error?: TwilioError;
};

export const MessageDeliveryErrorDialog = ({
  isLoading = false,
  isDelivered = false,
  open = false,
  setOpen,
  request,
  candidateUploadLink,
  onChangePhone,
  error,
}: InputProps) => {
  return (
    <CustomDialog open={open} setOpen={setOpen} title="Message Delivery Error">
      <div className={styles.root}>
        {isLoading ? (
          <AnimatedLoaderModal
            isLoading={!isDelivered}
            classNameWrapper={styles.loaderWrapper}
          />
        ) : (
          <MessageDeliveryErrorForm
            request={request}
            candidateUploadLink={candidateUploadLink}
            onChangePhone={onChangePhone}
            error={error}
          />
        )}
      </div>
    </CustomDialog>
  );
};
